import "../style/Header.scss";
import React, { useState } from "react";
import AccountModal from "@widgets/AccountModal";
import EditBalance from "@features/EditBalance";
import Reload from "@features/Reload";
import SearchBar from "@features/SearchBar";
import { useMediaQuery } from "@shared/First";

const Header = ({ onSearch, user, isEditingStocks, onEdit, onCancel, onSave, isSavingStocks, searchValue }) => {
  const isMobile = useMediaQuery("(max-width: 800px)");
  const [showAccount, setShowAccount] = useState(false);

  return (
    <header className="header">
      <div className="header__left">
        <div className="header__logo">
          <img src="/img/logo.png" alt="logo" />
        </div>

        {!isMobile && (
          <>
            <Reload />
            <SearchBar onSearch={onSearch} searchValue={searchValue} />
          </>
        )}
      </div>

      <div className="header__right">
        {!isMobile && (
          <EditBalance
            isEditing={isEditingStocks}
            onEdit={onEdit}
            onCancel={onCancel}
            onSave={onSave}
            isSavingStocks={isSavingStocks}
          />
        )}
        <button className="header__account" onClick={() => setShowAccount(true)}>
          👤 Аккаунт
        </button>
      </div>

      {showAccount && (
        <AccountModal
          user={{ name: user?.name, role: user?.roles?.[0]?.name }}
          onClose={() => setShowAccount(false)}
          onLogout={() => {
            localStorage.removeItem("token");
            window.location.reload();
          }}
        />
      )}
    </header>
  );
};

export default Header;
